import(/* webpackMode: "eager" */ "/build-cache/890318871/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/woodpecker/src/github.com/wisflux/school-erp/packages/parent-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/woodpecker/src/github.com/wisflux/school-erp/packages/parent-frontend/src/app/providers.tsx");
